module.exports = __webpack_public_path__ + "static/media/appwiz_1503.2c3e8839.ico";